
import React, { memo } from 'react';
import _ from 'lodash';
import SingleInstrumentSelector from 'v2/common/components/SingleInstrumentSelector/index';
import classNames from 'classnames';
import ModeSelector from './ModeSelector';
import useInstrumentDetails from '../../hooks/useInstrumentDetails/index';
import GlobalSegmentSelector from './GlobalSegmentSelector';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const InstrumentDetails = () => {
  const {
    instrumentGroups,
    maxInstrumentsInGroup,
    maxInstrumentGroups,
    isAdvancedMode,
    onUpdateInstrumentGroups,
    onUpdateInstrument,
    onDeleteInstrumentGroup,
    onAddInstumentGroup,
    onChangeMode,
    mode,
  } = useInstrumentDetails();

  let instrumentLength = new Array(ApplicationDomainUtility.isAdmin ? 25 : 3).fill(1).map((_,idx)=> idx + 1)

  const renderInstrumentSelector = (instrumentGroupIndex, instrumentIndex, prependLabel = '') => {
    return (
      <SingleInstrumentSelector
        instrument={_.get(instrumentGroups, [instrumentGroupIndex, instrumentIndex], '')}
        prependLabel={prependLabel}
        onUpdateInstrument={(newInstrument) =>
          onUpdateInstrument(newInstrument, instrumentGroupIndex, instrumentIndex)
        }
      />
    );
  };

  const renderDeleteBtn = (instrumentGroupIndex) => {
    return (
      <button
        type="button"
        className="btn btn-outline-secondary me-2"
        onClick={() => onDeleteInstrumentGroup(instrumentGroupIndex)}
      >
        <i className="fa-light fa-trash-can"></i>
        <span className="ms-1 tx-12">Delete Strategy</span>
      </button>
    );
  };

  const renderAddBtn = () => {
    return (
      <button type="button" className="btn btn-outline-secondary me-2" onClick={onAddInstumentGroup}>
        <span>
          <i className="fa-light fa-plus me-1"></i>Add Strategy
        </span>
      </button>
    );
  };

  const renderAddOrDeleteBtn = (instrumentGroupIndex) => {
    if (instrumentGroupIndex === 0 && maxInstrumentGroups === 1) {
      return renderAddBtn(instrumentGroupIndex);
    }

    return instrumentGroupIndex === maxInstrumentGroups - 1
      ? renderAddBtn(instrumentGroupIndex)
      : renderDeleteBtn(instrumentGroupIndex);
  };

  const renderAdvancedModeInstrumentGroupsSelector = () => {
    return _.range(0, maxInstrumentGroups).map((instrumentGroupIndex) => {
      return (
        <div className="startegy-main-container" key={instrumentGroupIndex}>
          <label className="label_style mb-2 mb-md-0">
            Strategy
            {instrumentGroupIndex + 1}
          </label>
          <div className="instrument-strategy-item" key={instrumentGroupIndex}>
            {_.range(0, maxInstrumentsInGroup).map((instrumentIndex) => {
              return (
                <React.Fragment key={_.uniqueId('instrument_')}>
                  {renderInstrumentSelector(
                    instrumentGroupIndex,
                    instrumentIndex,
                    `Item ${instrumentIndex + 1}`
                  )}
                </React.Fragment>
              );
            })}
            {renderAddOrDeleteBtn(instrumentGroupIndex)}
          </div>
        </div>
      );
    });
  };

  const renderMaxInstrumentsInGroupSelector = () => {
    return (
      <>
        <div className="d-flex align-items-center strategy">
          <span className="selector-text ">{!isAdvancedMode ? 'Instrument' : 'Strategy Based on'}</span>
          <GlobalSegmentSelector />
        </div>
        {isAdvancedMode && (
          <select
            className="ml-1 select-instrument"
            value={maxInstrumentsInGroup}
            onChange={(event) => onUpdateInstrumentGroups([], event.target.value)}
          >
            {instrumentLength.map((value) => {
              return (
                <option value={value} key={value}>
                  {value} Instrument
                </option>
              );
            })}
          </select>
        )}
      </>
    );
  };

  const flexClassNameModeBased = classNames({ 'item-finder': !isAdvancedMode });
  const maxInstrumentClassName = classNames('d-flex align-items-center flex-wrap', {
    'strategy-container': true,
    'mb-2': isAdvancedMode,
  });

  return (
    <div className="instrument_wrap instrument-group-type-container">
      <div className="instrument_wrap__selection-panel">
        <div className="instrument_wrap__instrument-group">
          <div className={flexClassNameModeBased}>
            <div className={maxInstrumentClassName}>{renderMaxInstrumentsInGroupSelector()}</div>
            {!isAdvancedMode && <div className="instrument_wrap__instrument-group-builder">{renderInstrumentSelector(0, 0)}</div>}
          </div>
        </div>
        <div className="instrument_wrap__mode-selector">
          <ModeSelector mode={mode} onChange={onChangeMode} />
        </div>
      </div>
      <div className="instrument_wrap__advanced-mode">
        {isAdvancedMode && renderAdvancedModeInstrumentGroupsSelector()}
      </div>
    </div>
  );
};

export default memo(InstrumentDetails);
